//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { ReactNode, SyntheticEvent } from 'react';
import { Tabs as MuiTabs, SxProps, TabsTypeMap } from '@mui/material';
import styled from '@emotion/styled';

type TabsProps = {
  children: ReactNode;
  className?: string;
  value?: number;
  onChange: (event: SyntheticEvent<Element, Event>, value: any) => void;
  orientation?: TabsTypeMap['props']['orientation'];
  color?: 'primary' | 'warning' | 'success' | 'error' | 'default' | 'pending';
  sx?: SxProps;
};

const Tabs = ({ children, color = 'primary', sx, ...props }: TabsProps) => (
  <StyledTabs color={color} sx={sx} {...props}>
    {children}
  </StyledTabs>
);

export default Tabs;

const StyledTabs = styled(MuiTabs)<{ color: TabsProps['color'] }>`
  ${({ theme, color = 'primary' }) => `
  margin-bottom: ${theme.spacing(2)};
  position: relative;
  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: ${theme.palette.divider};
    position: absolute;
    left: 0;
    right: 0;
    bottom: 1px;
  }
  .MuiTab-root {
    min-width: auto;
    border-radius: 15px 15px 0 0;
    opacity: .6;
    transition: opacity 0.3s;
    &.Mui-selected {
      transition: opacity 0.3s;
      opacity: 1;
      color: ${theme.palette[color].main};
      .MuiBadge-root {
        background: ${theme.palette[color].main};
      }
    }
  }
  
 .MuiTabs-indicator {
    background-color: ${theme.palette[color].main};
    height: 4px;
  }
`}
`;
